<!-- tinymc富文本 -->
<template>
  <div>
    <editor
        v-model="myValue"
        :init="init"
        :disabled="disabled"
        @onClick="onClick"
    >
    </editor>
  </div>
</template>

<script>
import tinymce from "tinymce/tinymce";
import Editor from "@tinymce/tinymce-vue";
import "tinymce/skins/ui/oxide/skin.css";
import "@/assets/tinymce/zh_CN.js"; // 本地汉化
import "tinymce/themes/silver/theme";
import "tinymce/plugins/image";
import 'tinymce/plugins/media'
import 'tinymce/plugins/table'
import "tinymce/plugins/lists";
import "tinymce/plugins/contextmenu";
import "tinymce/plugins/wordcount";
import "tinymce/plugins/colorpicker";
import "tinymce/plugins/textcolor";
import "tinymce/icons/default";
import "tinymce/plugins/link"; //超链接
import axios from "@/util/axios";

import {watch} from "vue";

export default {
  emits: ["update:modelValue"],
  name: "tinymce",
  components: {
    Editor,
  },
  props: {
    // 图片文件夹，这个图片要放在哪里
    folder: {default: "common"},
    //传入一个value，使组件支持v-model绑定
    modelValue: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    // 上传图片路径
    uploadUrl: {default: "/basedata/common/updateImage"},
    plugins: {
      type: [String, Array],
      default:
      // ' anchor autolink autosave code codesample colorpicker colorpicker contextmenu directionality emoticons fullscreen hr image imagetools insertdatetime link lists   noneditable pagebreak paste preview print save searchreplace spellchecker tabfocus table template textcolor textpattern visualblocks visualchars wordcount'
          "lists image table  wordcount ",
    },
    toolbar: {
      type: [String, Array],
      default:
      // 'undo redo | searchreplace | bold  italic | underline | strikethrough | alignleft  aligncenter alignright | outdent indent  blockquote  removeformat subscript superscript code codesample hr bullist numlist link image charmap preview anchor pagebreak insertdatetime  table  forecolor backcolor'
          "undo redo |  formatselect | bold italic underline | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | lists image media table | removeformat hr",
    },
  },
  data() {
    return {
      //初始化配置
      init: {
        language_url: "@/asset/tinymce/langs/zh_CN.js", // 这里需要单独处理
        language: "zh_CN",
        skin_url: '/tinymce/skins/ui/oxide', // skin路径
        content_css: '/tinymce/skins/content/document/content.css',
        height: 500,
        width:1200,
        plugins: this.plugins,
        toolbar: this.toolbar,
        branding: true,
        menubar: true,
        //此处为图片上传处理函数，这个直接用了base64的图片形式上传图片，
        //如需ajax上传可参考https://www.tiny.cloud/docs/configure/file-image-upload/#images_upload_handler
        images_upload_handler: (blobInfo, success, failure) => {
          const formData = new FormData();
          formData.append("file", blobInfo.blob());
          formData.append("folder", this.folder);
          // 上传图片
          axios.post({url: this.uploadUrl, data: formData}).then(data => {
            success(process.env.VUE_APP_FILE_URL + data);
          }).catch(() => {
            failure();
          });
        },
        resize: true,
      },
      myValue: this.value,
    };
  },
  mounted() {
    watch(() => this.modelValue, () => this.parentUpdated());
    watch(() => this.myValue, () =>this.$emit("update:modelValue", this.myValue));
    tinymce.init({});
  },
  methods: {
    //添加相关的事件，可用的事件参照文档=> https://github.com/tinymce/tinymce-vue => All available events
    //需要什么事件可以自己增加
    onClick(e) {
      this.$emit("onClick", e, tinymce);
    },
    clear() {
      this.myValue = "";
    },
    parentUpdated() {
      this.myValue = this.modelValue;
    }
  },
};
</script>
<style scoped lang="scss">
:deep(.tox-tinymce) {
  width: 100% !important;
}
</style>
